import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
import { PayPalSetting } from "../../../../models/features/Gravity/Gravity";

export const gravitySettingApi = createApi({
  reducerPath: "gravitySettingApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    addGravitySetting: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/AddGravitySetting`,
        method: "post",
        data: data,
      }),
    }),
    addPayPalSetting: build.mutation<any, { data: PayPalSetting }>({
      query: ({ data }) => ({
        url: `api/AddPayPalSetting`,
        method: "post",
        data: data,
      }),
    }),
    updateGravitySetting: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/UpdateGravitySetting`,
        method: "put",
        data: data,
      }),
    }),
    updatePayPalSetting: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/UpdatePayPalSetting`,
        method: "put",
        data: data,
      }),
    }),
    getGravitySettings: build.query<any, void>({
      query: () => ({
        url: `api/GetGravitySettings`,
      }),
    }),
    getPayPalSettings: build.query<any, void>({
      query: () => ({
        url: `api/GetPayPalSettings`,
      }),
    }),
    setSettingDefault: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/SetSettingDefault`,
        method: "post",
        data: data,
      }),
    }),
    setSettingActive: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/SetSettingActive`,
        method: "post",
        data: data,
      }),
    }),
    deleteGravityGatewaySetting: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/DeleteGravityGatewaySetting`,
        method: "delete",
        data: data,
      }),
    }),
    deletePayPalSetting: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/DeletePayPalSetting`,
        method: "delete",
        data: data,
      }),
    }),
    setPayPalSettingDefault: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/SetPayPalSettingDefault`,
        method: "post",
        data: data,
      }),
    }),
    setPayPalSettingActive: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/SetPayPalSettingActive`,
        method: "post",
        data: data,
      }),
    }),
    verifyGravityConfiguration: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/GravityGateway/VerifyGravityConfiguration`,
        method: "post",
        data: data,
      }),
    }),
    verifyPayPalConfiguration: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/PayPal/VerifyPayPalConfiguration`,
        method: "post",
        data: data,
      }),
    }),
  }),
});

export const {
  useGetGravitySettingsQuery,
  useAddGravitySettingMutation,
  useAddPayPalSettingMutation,
  useUpdateGravitySettingMutation,
  useSetSettingActiveMutation,
  useSetSettingDefaultMutation,
  useDeleteGravityGatewaySettingMutation,
  useGetPayPalSettingsQuery,
  useUpdatePayPalSettingMutation,
  useDeletePayPalSettingMutation,
  useSetPayPalSettingActiveMutation,
  useSetPayPalSettingDefaultMutation,
  useVerifyGravityConfigurationMutation,
  useVerifyPayPalConfigurationMutation,
} = gravitySettingApi;
export const gravitySettingReducer = gravitySettingApi.reducer;
